import React from 'react';
import TextField from '@mui/material/TextField';

const applyMask = (value, mask) => {
  let maskedValue = '';
  let rawValueIndex = 0;

  for (let i = 0; i < mask.length; i++) {
    if (mask[i] === '9') {
      if (rawValueIndex < value.length) {
        maskedValue += value[rawValueIndex];
        rawValueIndex++;
      } else {
        break;
      }
    } else {
      maskedValue += mask[i];
    }
  }

  return maskedValue;
};

export const MaskedTextField = ({
  id,
  name,
  value,
  onChange,
  mask,
  label,
  icon,
  InputProps,
  ...props
}) => {
  const handleChange = (event) => {
    let rawValue = event.target.value.replace(/\D/g, '');

    if (name === 'phone') {
      if (rawValue.length === 10 && rawValue[2] !== '9') {
        rawValue = rawValue.slice(0, 2) + '9' + rawValue.slice(2);
      }

      if (rawValue.length > 11) {
        rawValue = rawValue.slice(0, 11);
      }
    }

    onChange({
      target: {
        name,
        value: rawValue,
      },
    });
  };


  const maskedValue = applyMask(value, mask);

  return (
    <TextField
      {...props}
      id={id}
      name={name}
      label={label}
      value={maskedValue}
      onChange={handleChange}
      variant="outlined"
      fullWidth
      InputProps={{
        startAdornment: icon,
        ...InputProps,
      }}
    />
  );
};

export default MaskedTextField;
